import { derivePalette, deriveTokens, type ThemeRecipe } from '../recipe';
import type { Theme } from '../types';

// Aurinko — sunrise. Recipe-driven: warm orange→amber→cream gradient
// with butterflies drifting horizontally. Pairs well as a per-routine
// override on a morning routine (tasks/v2-themes.md §D4).
const recipe: ThemeRecipe = {
  base: '#fb923c', // orange 400
  secondary: '#fbbf24', // amber 400
  tertiary: '#fde68a', // amber 200 — pale dawn
  mood: 'bright',
};

export const aurinkoTheme: Theme = {
  key: 'aurinko',
  name: 'Aurinko',
  tokens: deriveTokens(recipe),
  decoration: {
    kind: 'spec',
    spec: {
      sprite: 'butterfly',
      motion: 'drift',
      density: 'low',
      speed: 'slow',
    },
  },
  routineCardPalette: derivePalette(recipe),
};
